/**
 * Voice Action Registry
 * --------------------------------------------------------------
 * Sayfadaki component'ler, sesli agent'ın yapabileceği "action"ları
 * buraya kaydeder. Agent (Kie Claude) yalnızca o anda kayıtlı olan
 * action kataloğunu görür → "sayfayı bu yüzden bilir".
 *
 * Her action: makineye okunur açıklama + (varsa) parametreler +
 * cursor animasyonu için hedef element + çalıştırma fonksiyonu.
 */

export type VoiceActionParam = {
  name: string;
  type?: 'string' | 'number' | 'boolean';
  description?: string;
  required?: boolean;
  enum?: string[];
};

export type VoiceAction = {
  /** Tool adı (benzersiz, snake_case). Örn: 'open_view', 'type_in_editor' */
  id: string;
  /** Modelin anlayacağı kısa açıklama (Almanca/İngilizce). */
  description: string;
  /** Geri alınamaz işlem (gönder, kaydet) → model önce onay ister. */
  destructive?: boolean;
  /** Tool parametreleri (input_schema). */
  params?: VoiceActionParam[];
  /** Cursor'un üzerine kayacağı DOM elementi (opsiyonel). */
  getTarget?: () => HTMLElement | null;
  /** Action'ı çalıştır. Dönen değer modele tool_result olarak gider. */
  run: (args: Record<string, any>) => any | Promise<any>;
};

const registry = new Map<string, VoiceAction>();

export function registerVoiceAction(action: VoiceAction): void {
  registry.set(action.id, action);
}

export function unregisterVoiceAction(id: string): void {
  registry.delete(id);
}

export function getVoiceAction(id: string): VoiceAction | undefined {
  return registry.get(id);
}

export function getVoiceActions(): VoiceAction[] {
  return Array.from(registry.values());
}

/** Backend'e gönderilecek katalog (fonksiyonlar olmadan, sadece şema). */
export function getActionCatalog() {
  return getVoiceActions().map(({ id, description, destructive, params }) => ({
    id,
    description,
    destructive: !!destructive,
    params: params || [],
  }));
}
